// src/routes/callback.tsx
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import userManager from '../auth/authConfig';
import Loader from '../components/Loader/Loader';

export const Route = createFileRoute('/callback')({
  component: CallbackPage,
});

function CallbackPage() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Previeni chiamate multiple in React Strict Mode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    userManager
      .signinRedirectCallback()
      .then(() => {
        // Recupera l'URL salvato prima del login
        const redirectPath =
          sessionStorage.getItem('redirectAfterLogin') || '/';
        sessionStorage.removeItem('redirectAfterLogin');

        // Naviga all'URL originale
        navigate({ to: redirectPath, replace: true });
      })
      .catch(() => {
        navigate({ to: '/' });
      });
  }, [navigate]);

  return (
      <Loader fullScreen />
  );
}
